import * as React from 'react';

function SvgRedAlertCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}>
      <rect width={32} height={32} fill="#ED0006" fillOpacity={0.13} rx={16} />
      <path
        fill="#ED0006"
        d="M16 6C10.48 6 6 10.48 6 16s4.48 10 10 10 10-4.48 10-10S21.52 6 16 6zm0 11c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
      />
    </svg>
  );
}

export default SvgRedAlertCircle;
